export const BANK_ACCOUNT_LENGTHS: Record<string, number> = {
  '001': 8,
  '003': 6,
  '004': 6,
  '021': 8,
  '033': 9,
  '037': 9,
  '041': 9,
  '047': 8,
  '070': 9,
  '077': 9,
  '082': 7,
  '084': 6,
  '085': 11,
  '089': 9,
  '093': 6,
  '097': 7,
  '099': 6,
  '104': 12,
  '121': 10,
  '125': 4,
  '133': 8,
  '136': 8,
  '173': 6,
  '174': 7,
  '197': 7,
  '208': 7,
  '212': 7,
  '218': 9,
  '237': 7,
  '260': 10,
  '273': 5,
  '274': 8,
  '290': 8,
  '301': 10,
  '310': 3,
  '318': 8,
  '323': 10,
  '332': 9,
  '336': 8,
  '341': 9,
  '355': 5,
  '364': 8,
  '376': 11,
  '383': 10,
  '384': 9,
  '389': 8,
  '403': 8,
  '412': 9,
  '422': 8,
  '450': 9,
  '451': 10,
  '461': 7,
  '613': 6,
  '623': 9,
  '633': 10,
  '655': 9,
  '707': 7,
  '735': 10,
  '741': 10,
  '745': 8,
  '746': 9,
  '748': 9,
  '752': 6,
  '756': 9,
};
